/**
 * Helper functions for cookie management
 */

import { siteConfig } from '../config/siteConfig';

// Cookie constants
export const COOKIE_CONSENT_KEY = 'cookieConsent';

const DOMAIN =
  import.meta.env.MODE === 'production' ? `.${siteConfig.domain}` : 'localhost';

/**
 * Get a cookie value by name
 */
export const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift() || null;
  return null;
};

/**
 * Set a cookie with the given name, value, and expiration days
 */
export const setCookie = (name: string, value: string, days: number = 365) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/; domain=${DOMAIN}; SameSite=Lax`;
};
